import { Button, Dialog, RadixDialogPrimitives } from '@capsule/consumer-design-system';

import { useHistory } from 'react-router';
import { css } from 'styled-components';

import {
  SimpleFeatureLayout,
  SimpleFeatureLayoutPageContainer,
} from 'src/app/components/FeatureLayouts/SimpleFeatureLayout/SimpleFeatureLayout';
import { PillBottleArt } from 'src/app/components/Pages/EscriptOnboarding/steps/AllDoctorsAllMeds';
import { MessagesArt } from 'src/app/components/Pages/EscriptOnboarding/steps/SayCapsule';
import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import { loggedInTransferPrompt } from 'src/app/router/paths';

export const PostOrderPrompt = () => {
  const { push, goBack } = useHistory();

  useSegmentEvent('viewPostOrderGetMyMeds', { shouldTrackOnMount: true });

  const trackPositiveCTAClick = useSegmentEvent('selectTransferMedsPOTS', { shouldTrackOnMount: false });
  const trackNegativeCTAClick = useSegmentEvent('selectDoNotTransferMedicationPOTS', { shouldTrackOnMount: false });

  return (
    <SimpleFeatureLayoutPageContainer key="pots-experiment-post-order-prompt">
      <SimpleFeatureLayout
        keyName="pots-experiment-post-order-prompt"
        title="95% of Capsule customers get all their meds from Capsule"
        description="It takes less than 15 seconds to move your other meds. We work with all insurances."
        body={{
          content: (
            <PillBottleArt
              css={css`
                width: 375px;
                height: 283px;
              `}
            />
          ),
          type: 'artwork',
        }}
        cta1={{
          children: 'Move my meds',
          onClick: () => {
            trackPositiveCTAClick();
            push(loggedInTransferPrompt.route);
          },
        }}
        cta2={
          <Dialog
            title="Sure, use Capsule anytime"
            description="If you want to get your other meds delivered for free, just tell your doctor “Capsule.”"
            triggerButton={{
              children: 'Not Right Now',
              onClick: () => trackNegativeCTAClick(),
              variant: 'text-md',
              isFullWidth: true,
            }}
          >
            <MessagesArt />

            <RadixDialogPrimitives.Close asChild>
              <Button variant="contained-secondary-lg" isFullWidth onClick={goBack}>
                Done
              </Button>
            </RadixDialogPrimitives.Close>
          </Dialog>
        }
      />
    </SimpleFeatureLayoutPageContainer>
  );
};
